var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7495 12.1666C13.6228 12.1666 13.4961 12.12 13.3961 12.02L9.02948 7.65329L8.30281 8.74663C8.22281 8.87329 8.08281 8.95329 7.93615 8.96663C7.78281 8.97996 7.63615 8.92663 7.53615 8.81996L3.40281 4.68663C3.20948 4.49329 3.20948 4.17329 3.40281 3.97996C3.59615 3.78663 3.91615 3.78663 4.10948 3.97996L7.80948 7.67996L8.53615 6.58663C8.61615 6.46663 8.74948 6.38663 8.90281 6.36663C9.05615 6.35329 9.20281 6.40663 9.30281 6.51329L14.1028 11.3133C14.2961 11.5066 14.2961 11.8266 14.1028 12.02C14.0028 12.12 13.8761 12.1666 13.7495 12.1666Z",
    fill: "#FB0B24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7495 12.1666H12.4161C12.1428 12.1666 11.9161 11.94 11.9161 11.6666C11.9161 11.3933 12.1428 11.1666 12.4161 11.1666H13.2495V10.3333C13.2495 10.06 13.4761 9.83329 13.7495 9.83329C14.0228 9.83329 14.2495 10.06 14.2495 10.3333V11.6666C14.2495 11.94 14.0228 12.1666 13.7495 12.1666Z",
    fill: "#FB0B24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend-down.d80d13944101ac4c64c28101a1f046f1.svg";
export { ForwardRef as ReactComponent };